module.exports = ".qr-text {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}"